//------------------------------------------------------ funciones
import {
  subscribeTable,
  createRow,
  updateRow,
  deleteRow,
} from "../supabaseRealtime";
import { supabase } from "../../supabase/SupabaseClient";
import { limpiarFecha } from "../../functions/dataFunctions";

const TABLA = "cargas_combustible";

// -------------------------------------------------- realtime

export const subscribeCargasCombustible = (callback) =>
  subscribeTable(TABLA, (rows) => {
    callback([...rows].sort((a, b) => limpiarFecha(a.fecha) - limpiarFecha(b.fecha)));
  });

// devuelve, de toda la coleccion en memoria, solo las cargas de un viaje
// (ya vienen ordenadas por fecha ascendente desde el subscribe de arriba)
export const getCargasDeViaje = (cargas, viajeId) =>
  (cargas || []).filter((c) => String(c.viaje) === String(viajeId));

// -------------------------------------------------- metodos

const generarIdCarga = async () => {
  const { data: nuevo, error } = await supabase.rpc("incrementar_contador", {
    tabla: "contadores",
    fila_id: "cargas_combustible",
  });
  if (error) throw error;
  return `CC${String(nuevo).padStart(8, "0")}`;
};

export const createCarga = async ({
  viaje,
  interno,
  fecha,
  litros,
  kilometros,
  lugar = "",
}) => {
  const id = await generarIdCarga();
  await createRow(TABLA, id, {
    viaje,
    interno,
    fecha,
    litros: Number(litros) || 0,
    kilometros: Number(kilometros) || 0,
    lugar,
  });
  return id;
};

export const updateCarga = (id, data) => updateRow(TABLA, id, data);

export const deleteCarga = (id) => deleteRow(TABLA, id);
